import { bffRestClient } from 'APP/restApi/restClient/restClient';

const ROOT_API = 'auth';

const authClient = bffRestClient.createSubApiClient({ rootApi: ROOT_API });
let unauthorizedAuthClient: ReturnType<typeof bffRestClient.createSubApiClient> | null = null;

export const initUnauthorizedAuthClient = (baseUrl: string): void => {
  unauthorizedAuthClient = bffRestClient.createSubApiClient({
    rootApi: ROOT_API,
    baseUrl: `${baseUrl}/api/v1`,
  });
};

export const unauthorizedRefreshToken = (data: ArrayBufferView): Promise<ArrayBuffer> => {
  if (!unauthorizedAuthClient) {
    throw new Error('unauthorizedAuthClient must be initiated with correct base url');
  }
  return unauthorizedAuthClient.post<ArrayBuffer, ArrayBufferView>(
    'token/refresh',
    {
      body: data,
    },
    'unauthorizedRefreshTokenRequest'
  );
};

export const unauthorizedLogin = (data: ArrayBufferView): Promise<ArrayBuffer> => {
  if (!unauthorizedAuthClient) {
    throw new Error('unauthorizedAuthClient must be initiated with correct base url');
  }
  return unauthorizedAuthClient.post<ArrayBuffer, ArrayBufferView>(
    'login',
    {
      body: data,
    },
    'unauthorizedLoginRequest'
  );
};

export const login = (data: ArrayBufferView): Promise<ArrayBuffer> => {
  return authClient.post<ArrayBuffer, ArrayBufferView>(
    'login',
    {
      body: data,
    },
    'loginRequest'
  );
};

export const loginByCode = (data: ArrayBufferView): Promise<ArrayBuffer> => {
  return authClient.post<ArrayBuffer, ArrayBufferView>(
    'code/login',
    {
      body: data,
    },
    'loginByCodeRequest'
  );
};

export const logout = (data: ArrayBufferView): Promise<ArrayBuffer> => {
  return authClient.post<ArrayBuffer, ArrayBufferView>(
    'logout',
    {
      body: data,
    },
    'logoutRequest'
  );
};

export const refreshToken = (data: ArrayBufferView): Promise<ArrayBuffer> => {
  return authClient.post<ArrayBuffer, ArrayBufferView>(
    'token/refresh',
    {
      body: data,
    },
    'refreshTokenRequest'
  );
};

export const getAuthUrl = (): Promise<ArrayBuffer> => {
  return authClient.post<ArrayBuffer, ArrayBufferView>('url', {}, 'getAuthUrlRequest');
};

export const getRegistrationUrl = (): Promise<ArrayBuffer> => {
  return authClient.post<ArrayBuffer, ArrayBufferView>(
    'registrationUrl',
    {},
    'getRegistrationUrlRequest'
  );
};
